'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('survey-edit', {
      url: '/admin/survey/edit/:id',
      template: '<survey-edit></survey-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/survey/edit/survey-edit.routes.js